var timeout = null
export default {
    debounce(fn, wait) {
        if (timeout !== null) clearTimeout(timeout)
        timeout = setTimeout(fn, wait)
    },
    //这是打开 删除 操作弹出框的公共方法
    openDelDialogAndHandleData(self, msg, type, role, roleID) {
        self.$confirm(msg, type, {
            confirmButtonText: self.$t('lang.message.btnYes'),
            cancelButtonText: self.$t('lang.message.btnNo'),
            type: 'warning'
        }).then(() => {
            self.$http.delete('TC/' + role + '/' + roleID).then(res => {
                var data = res.data;
                if (data.status === 200) {
                    self.$message.success(self.$t('lang.message.boxDelSuccess'));
                    if (self.userData.length === 1) self.pageNum -= 1;
                    self.$http.get("TC/" + role + "?pageNum=" + self.pageNum + "&pageSize=" + self.pageSize).then(ores => {
                        var _data = ores.data.data;
                        self.userData = _data.users;
                        self.totalPage = _data.total;
                        self.userData.forEach((el, i) => {
                            self.userData[i].index = (self.pageNum - 1) * self.pageSize + 1 + i;
                          });
                    }).catch(err => {
                        window.console.log(err);
                    });
                }
                window.console.log(data);
            }).catch(err => {
                window.console.log(err);
            })
        }).catch(() => {
            self.$message.info(self.$t('lang.message.boxDelCancel'));
        });
    }
}